import {makeAutoObservable, observable} from "mobx";
import {inject, injectable} from "inversify";
import {AxiosError} from "axios";
import {ViewController} from "data/types/structure";
import {Bindings} from "data/constants/bindings";
import {type ICommonApiProvider} from "data/providers/api/common.api.provider";
import {ModalType} from "data/enums";
import {extractErrorMessage} from "data/utils";
import {IApiResponse} from "data/services/http";
import {type IModalsStore} from "data/stores/modals/modals.store";
import {type ILocalizationStore} from "data/stores/localization/localization.store";
import {ALLOWED_GEOLOCATIONS} from "data/constants";

export interface IGeoBlockingController extends ViewController {
	readonly i18n: ILocalizationStore;
	get isAllow(): boolean;
	get isLoading(): boolean;
}

@injectable()
export class GeoBlockingController implements IGeoBlockingController {
	@observable private _isAllow: boolean = true;
	@observable private _isLoading: boolean = true;

	constructor(
		@inject(Bindings.CommonApiProvider) private _commonApi: ICommonApiProvider,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore,
		@inject(Bindings.LocalizationStore) readonly i18n: ILocalizationStore
	) {
		makeAutoObservable(this);
	}

	get isAllow() {
		return this._isAllow;
	}

	get isLoading() {
		return this._isLoading;
	}

	async init() {
		try {
			const response = await this._commonApi.geo();
			const countryCode = response.data.success.isoCode;
			this._isAllow = ALLOWED_GEOLOCATIONS.includes(countryCode);
		} catch (error) {
			this._modalsStore.showModal(ModalType.ERROR, {
				message: extractErrorMessage(error as AxiosError<IApiResponse>),
			});
		} finally {
			this._isLoading = false;
		}
	}
}
